<template>
  <div
    v-if="whitelabel.omDesign"
    class="omk-text-field-container"
    :class="{
      'remainder-of-estate-margin': remainderOfEstateMargin,
      'calculator-margins': calculatorMargins,
    }"
  >
    <div
      v-if="$slots.prepend"
      class="prepend-slot"
      :class="{ 'is-country-code': isCountryCode }"
    >
      <slot name="prepend" />
    </div>
    <omk-text-field
      :value="value"
      :label="label"
      :placeholder="placeholder"
      :custom-validation-message="errors[0]"
      :required="required"
      :type="type"
      :disabled="disabled"
      :read-only="readonly"
      :autocomplete="autocomplete"
      :supporting-text="hint"
      :suffix-text="suffix"
      :prefix-text="prefix"
      :text-direction="computedTextDirection"
      :max="max"
      :min="min"
      class="omk-text-field"
      :class="{
        'calculator-margins': calculatorMargins,
        'default-margin': defaultMargin,
      }"
      @input="handleInput"
      @change="$emit('change', $event)"
      @blur="$emit('blur', $event)"
      @click="handleClick"
      @focus="$emit('focus', $event)"
      @keypress="$emit('keypress', $event)"
      :rows="rows"
    />
  </div>
  <v-text-field
    v-else
    :value="value"
    :label="label"
    :error-messages="errors"
    :placeholder="placeholder"
    :type="type"
    :prefix="prefix"
    :suffix="suffix"
    :required="required"
    :autocomplete="autocomplete"
    :hint="hint"
    @input="handleInput"
    @change="$emit('change', $event)"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @keypress="$emit('keypress', $event)"
    @click="handleClick"
  >
    <template v-if="$slots.prepend" #prepend>
      <slot name="prepend" />
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: "TextField",
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    prefix: {
      type: String,
      default: "",
    },
    suffix: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    autocomplete: {
      type: String,
      default: "off",
    },
    hint: {
      type: String,
      default: "                                           ",
    },
    persistentHint: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    isDateField: {
      type: Boolean,
      default: false,
    },
    remainderOfEstateMargin: {
      type: Boolean,
      default: false,
    },
    max: {
      type: Number,
      default: null,
    },
    calculatorMargins: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 4,
    },
    defaultMargin: {
      type: Boolean,
      default: true,
    },
    isCountryCode: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: null,
    },
  },
  computed: {
    computedTextDirection() {
      return this.suffix === "%" ? "rtl" : this.textDirection;
    },
  },
  methods: {
    handleInput(event) {
      const value = event.target ? event.target.value : event;
      this.$emit("input", value);
    },
    handleClick(event) {
      this.$emit("click", event);
      if (this.isDateField) {
        this.$emit("date-picker-click", event);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.omk-text-field-container {
  display: flex;
  z-index: 0;
  .omk-text-field {
    &.default-margin {
      margin-bottom: 24px;
    }
  }
  &.remainder-of-estate-margin {
    margin: 6px 0 !important;
  }
  &.calculator-margins {
    margin: 0 !important;
  }
}

.is-country-code {
  padding-top: 0px;
  .vue-tel-input {
    padding: 9px;
    margin-right: 5px;
    border-radius: 15px;
  }
}
</style>
